<ion-header *ngIf="isComparisonMode" [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'energy_savings' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<app-header *ngIf="!isComparisonMode" [showMenuButton]="true" [showLogo]="true" (menuClick)="openMenu()">
</app-header>

<ion-content [fullscreen]="true">

  <div class="configuration-wrapper">
    <!-- Configuration Details Header -->
    <div class="config-header" *ngIf="!isComparisonMode">
      <h3>{{ 'configuration_details' | translate }}</h3>
      <p class="config-subtitle">{{ getConfigurationSummary() }}</p>

      <!-- Configuration status indicator -->
      <div *ngIf="isConfigNotSaved" class="saved-indicator saved-indicator-warning">
        <ion-icon src="assets/icons/not_saved_dot.svg"></ion-icon>
        <span>{{ 'configuration_not_saved' | translate }}</span>
      </div>

      <div *ngIf="isConfigHasUnsavedChanges" class="saved-indicator saved-indicator-danger">
        <ion-icon name="ellipse"></ion-icon>
        <span>{{ 'config_has_unsaved_changes' | translate }}</span>
      </div>

      <div *ngIf="isConfigSaved" class="saved-indicator saved-indicator-success">
        <ion-icon src="assets/icons/green-dot-icon.svg"></ion-icon>
        <span>{{ 'configuration_saved' | translate }}</span>
      </div>

    </div>
    @if (!saveOnlyGlass && !isComparisonMode) {
    <ion-chip color="primary" class="customChip primaryClass" style="margin-top: 0px;padding: 10px 12px;margin-bottom: 8px;">
      <ion-label>
        <div class="chip-content">
          <!-- <div class="chip-description">Uw = {{ projectData?.uw ?? 0 }} {{ projectData?.uwUnit }}</div> -->
          <div class="chip-description" style="font-weight: 700 !important; color: #00799E;">Uw =
            {{ (projectData?.uw ?? 0) < 1 ? ((projectData?.uw ?? 0) | number:'1.2-2') : ((projectData?.uw ?? 0) |
              number:'1.1-1') }} ({{ (projectData?.uw ?? 0) | number:'1.3-3' }}) W/m²K</div>
          </div>
      </ion-label>
    </ion-chip>
    }
    @if (showWindowTypeCard && !saveOnlyGlass) {

    <!-- Window Type -->
    <ion-card class="config-card" (click)="openWindowTypeModal()">
      <!-- Window Type Image (Left Side) -->
      <div class="config-icon">
        <img [src]="mappedWindowType?.img" [alt]="projectData?.windowtype?.name | translate"
          *ngIf="mappedWindowType?.img" />
      </div>

      <!-- Header with Title and Edit Button -->
      <ion-card-header>
        <ion-card-title class="config-title">{{ 'window_type' | translate }}</ion-card-title>
        <button class="edit-button" (click)="openWindowTypeModal(); $event.stopPropagation()">
          <ion-icon src="assets/icons/edit-icon.svg"></ion-icon>
          <span class="edit-text">{{ 'edit' | translate }}</span>
        </button>
      </ion-card-header>

      <!-- Card Content -->
      <ion-card-content>
        <div class="config-details">
          <p style="line-height: 16px !important;">{{ 'type' | translate }}: <strong>{{ getWindowTypeName() }}</strong>
            <br *ngIf="hasWindowTypeDesc()">
            <span style="font-weight: 500; margin-left: 36px;" *ngIf="hasWindowTypeDesc()">{{ getWindowTypeDesc()
              }}</span>
          </p>
          <p>a = <strong>{{ ((projectData?.dimensions?.a || 0)* 1000) }} mm</strong></p>
          <p>b = <strong>{{ ((projectData?.dimensions?.b || 0)* 1000) }} mm</strong></p>
          <p *ngIf="projectData?.dimensions?.c">c = <strong>{{ ((projectData?.dimensions?.c || 0)* 1000) }}
              mm</strong></p>
        </div>
      </ion-card-content>
    </ion-card>
    }
    @if (showFrameCard && !saveOnlyGlass) {
    <!-- Frame Card -->
    <ion-card class="config-card" (click)="openFrameModal()">
      <!-- Frame Image (Left Side) -->
      <div class="config-icon">
        <img [src]="getFrameImage()" alt="Frame" />
      </div>

      <!-- Header with Title and Edit Button -->
      <ion-card-header>
        <ion-card-title class="config-title">{{ 'frame' | translate }}</ion-card-title>
        <button class="edit-button">
          <ion-icon src="assets/icons/edit-icon.svg"></ion-icon>
          <span class="edit-text">{{ 'edit' | translate }}</span>
        </button>
      </ion-card-header>

      <!-- Card Content -->
      <ion-card-content>
        <div class="config-details">
          <p>{{ 'HEADER_MATERIAL' | translate }} <strong>{{ getFrameTitle() }}</strong></p>
          <p>U<sub>f</sub> = <strong> {{ getFrameWeightedUf() | number:'1.3-3' }} W/m²K</strong></p>
          <p *ngIf="shouldShowFrameWidth()">{{ 'FRAME_WIDTH_M' | translate }} <strong>{{
              projectData?.windowframe?.visibleWidth |
              number:'1.2-2' }} m</strong></p>
          <p *ngIf="shouldShowFrameArea()"><strong>{{ getFrameArea() | number:'1.3-3' }} m² </strong></p>
        </div>
      </ion-card-content>
    </ion-card>
    }
    @if (showGlassCard) {
    <!-- Glass Card -->
    <ion-card class="config-card" (click)="openGlassTypeModal()">
      <!-- Glass Image (Left Side) -->
      <div class="config-icon">
        <img [src]="getGlassImage(projectData?.windowglas?.glazingCount) || 'assets/images/glass/default.png'"
          alt="Glass" *ngIf="projectData?.windowglas?.id !== undefined" />
      </div>

      <!-- Header with Title and Edit Button -->
      <ion-card-header>
        <ion-card-title class="config-title">{{ 'glass' | translate }}</ion-card-title>
        <button class="edit-button" (click)="openGlassTypeModal(); $event.stopPropagation()">
          <ion-icon src="assets/icons/edit-icon.svg"></ion-icon>
          <span class="edit-text">{{ 'edit' | translate }}</span>
        </button>
      </ion-card-header>

      <!-- Card Content -->
      <ion-card-content>
        <div class="config-details" *ngIf="projectData?.windowglas?.id !== undefined; else noGlass">
          <p>{{ 'HEADER_NAME' | translate }} <strong>{{ projectData?.windowglas?.name || 'N/A' }}</strong></p>
          <p>{{ 'HEADER_STRUCTURE' | translate }} <strong>{{ projectData?.windowglas?.structure || 'N/A' }}</strong></p>
          <p>{{ 'HEADER_UG' | translate }} <strong>{{ (projectData?.windowglas?.ug || 0) | number:'1.1-1'}}
              W/m²K</strong></p>
          <p>{{ 'HEADER_G-VALUE' | translate }} <strong>{{ projectData?.windowglas?.gValue || 0 }}%</strong></p>
        </div>
        <ng-template #noGlass>
          <p class="empty-state">{{ 'no_glass_selected' | translate }}</p>
        </ng-template>
      </ion-card-content>
    </ion-card>
    }
    @if (showSpacerCard && !saveOnlyGlass) {
    <!-- Spacer Card -->
    <ion-card class="config-card" (click)="openSpacerModal()">
      <!-- Spacer Image (Left Side) -->
      <div class="config-icon">
        <img [src]="this.mappedWindowSpacer?.img || 'assets/images/spacer/other.png'" alt="Spacer"
          *ngIf="this.mappedWindowSpacer?.id !== undefined" class="spacerImg" />
      </div>

      <!-- Header with Title and Edit Button -->
      <ion-card-header>
        <ion-card-title class="config-title">{{ 'HEADER_SPACER' | translate }}</ion-card-title>
        <button class="edit-button" (click)="openSpacerModal(); $event.stopPropagation()">
          <ion-icon src="assets/icons/edit-icon.svg"></ion-icon>
          <span class="edit-text">{{ 'edit' | translate }}</span>
        </button>
      </ion-card-header>

      <!-- Card Content -->
      <ion-card-content>
        <!-- Advanced Mode: Show detailed info if spacerExpert exists -->
        <div class="config-details" *ngIf="hasSpacerExpertData(); else simpleSpacerView">
          <p>{{ 'type' | translate }}: <strong>{{ projectData?.windowSpacerType === 'manual' ?
              this.mappedWindowSpacer?.name : (this.mappedWindowSpacer?.name | translate) }}</strong></p>
          <p>Ψ<sub>g</sub> = <strong>{{ projectData?.psi | number:'1.3-3' }} W/mK</strong></p>
          <p>{{ 'HEADER_SEALANT' | translate }}: <strong>{{ projectData?.spacerExpert?.sealant?.name | translate
              }}</strong></p>
          <p>{{ 'HEADER_SEALANT_HEIGHT_PDF' | translate }} = <strong>{{ projectData?.spacerExpert?.sealant?.size
              }} mm</strong></p>
          <p>{{ 'HEADER_DESICCANT' | translate }}: <strong>{{ projectData?.spacerExpert?.desiccant?.name |
              translate }}</strong></p>
        </div>

        <!-- Simple Mode: Show only spacer name -->
        <ng-template #simpleSpacerView>
          <div class="config-details" *ngIf="this.mappedWindowSpacer?.id !== undefined; else noSpacer">
            <p>{{ 'HEADER_NAME' | translate }} <strong>{{ this.mappedWindowSpacer?.name | translate }}</strong></p>
            <p *ngIf="projectData?.psi != null">{{ 'HEADER_PSI_VALUE' | translate }}= <strong>{{ projectData?.psi |
                number:'1.3-3' }} W/mK</strong></p>
          </div>
          <ng-template #noSpacer>
            <p class="empty-state">{{ 'no_spacer_selected' | translate }}</p>
          </ng-template>
        </ng-template>
      </ion-card-content>
    </ion-card>
    }
    @if (showGeorgianCard && !saveOnlyGlass) {
    <!-- Georgian bar Card -->
    <ion-card class="config-card" (click)="openGeorgianBarsModal()">
      <!-- Georgian Image (Left Side) -->
      <div class="config-icon">
        <img [src]="this.mappedGeorgianBarShape?.img || 'assets/images/muntins/shapes/none.svg'" alt="Muntins"
          *ngIf="this.mappedGeorgianBarShape?.shape?.img !== undefined" />
      </div>

      <!-- Header with Title and Edit Button -->
      <ion-card-header>
        <ion-card-title class="config-title">{{ 'HEADER_MUNTINS_DETAIL' | translate }}</ion-card-title>
        <button class="edit-button">
          <ion-icon src="assets/icons/edit-icon.svg"></ion-icon>
          <span class="edit-text">{{ 'edit' | translate }}</span>
        </button>
      </ion-card-header>

      <!-- Card Content -->
      <ion-card-content>
        <div class="config-details">
          <p><strong>{{ projectData?.muntin?.shape?.name | translate}}</strong></p>
          <div *ngIf="projectData?.muntin?.shape?.id !== 1">
            <p>{{ 'HEADER_TYPE' | translate }} <strong>{{ projectData?.muntin?.type?.name | translate}}</strong>
            </p>
            <!-- <p>{{ 'HEADER_MATERIAL' | translate }} <strong>{{ projectData?.muntin?.spacer | translate}}</strong></p> -->
            <p>{{ 'HEADER_HORIZONTAL' | translate }} <strong>{{ projectData?.muntin?.shape?.countHorizontal}}</strong>
            </p>
            <p>{{ 'HEADER_VERTICAL' | translate }} <strong>{{ projectData?.muntin?.shape?.countVertical}}</strong></p>
            <!-- <p>{{ 'HEADER_DISTANCE_TO_PANE' | translate }} <strong>{{ projectData?.muntin?.spacer}}</strong></p> -->
            <p
              *ngIf="projectData?.muntin?.spacer == 'MUNTINSPACER_FIXED_ADDITION' || projectData?.windowmuntintin?.type?.id == 4">
              ΔUw = <strong>{{ this.resCalcDeltaUw }} W/m²K</strong></p>
            <p
              *ngIf="projectData?.muntin?.spacer != 'MUNTINSPACER_FIXED_ADDITION' && projectData?.windowmuntintin?.type?.id != 4">
              Ψs = <strong>{{ projectData?.muntin?.psi | number:'1.3-3'}} W/mK</strong></p>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
    }
  </div>

  <!-- Custom floating button with always visible label -->
  <div class="custom-fab-container" *ngIf="!isComparisonMode">
    <button class="custom-fab" (click)="openActionModal()">
      <div class="fab-content">
        <span class="fab-text">{{'actions' | translate}}</span>
        <ion-icon name="chevron-forward-outline" class="fab-icon"></ion-icon>
      </div>
    </button>
  </div>
</ion-content>
<!-- <ion-footer *ngIf="isComparisonMode" [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button class="next-btn" (click)="close()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
  </div>
</ion-footer> -->